import { VarmaBannerController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Varma banner component for displaying Varma popup
 * @example
 * ```html
 * <salaxy-varma-banner></salaxy-varma-banner>
 * ```
 */
export class VarmaBanner extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /** Current calculation */
      calc: "<"

    };

    /** Uses the VarmaBannerController */
    public controller = VarmaBannerController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/communications/VarmaBanner.html";

}
